import React from "react";
import * as ReactDOM from "react-dom/client";

import { ShoppingCartWithInventory } from '../components/Cart/ShoppingCart/cart-control'

const cartRoot = document.getElementById("cart-list-container");

if (cartRoot) {
  const rootx = ReactDOM.createRoot(cartRoot);
  rootx.render(<ShoppingCartWithInventory />);
}
